import script from "./cancellation.vue?vue&type=script&setup=true&lang=js"
export * from "./cancellation.vue?vue&type=script&setup=true&lang=js"

import "./cancellation.vue?vue&type=style&index=0&id=39624fbc&lang=css"

const __exports__ = script;

export default __exports__